import { useSelector } from 'react-redux';

import selectorUser from '@redux/user/selectors';
import { useCheckPermissions } from 'hooks/useCheckPermissions';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

const useCheckDisableWithdrawPublicationModal = (productData) => {
  const userInfo = useSelector(selectorUser.makeSelectUserInfo());
  const hasPermissionManageSyndication = useCheckPermissions([
    {
      action: ABILITY_ACTION.MAINTAIN,
      subject: ABILITY_SUBJECT.SYNDICATION,
    },
  ]);

  const isNotOwner = !productData?.isOwner;
  const isNotSyndication = !productData?.syndication;
  const isNotSubscribeShield =
    productData?.subscriptionShield !== 'None' ||
    productData?.subscriptionShield === 'NULL';
  const isGdsnShield = productData?.gdsnShield !== null;

  if (!productData) return true;

  if (!userInfo?.isRivirGdsnParty) return true;

  if (
    isNotOwner ||
    isNotSubscribeShield ||
    isGdsnShield ||
    isNotSyndication ||
    !hasPermissionManageSyndication
  ) {
    return true;
  }

  return false;
};

export { useCheckDisableWithdrawPublicationModal };
